import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import { noop } from 'lodash';
import defaultStyles from './GridButton.module.scss';

const OnRowClick = (props) => {
    const { id, onClick } = props;
    const onClickFunc = useCallback(() => onClick(id), [id, onClick]);
    return (
        <button
            onClick={ onClickFunc }
            className={ props.styles.gridButton }
            type="button"
        >
            {props.children}
        </button>
    );
};

OnRowClick.propTypes = {
    children: PropTypes.oneOfType([
        PropTypes.arrayOf(PropTypes.element),
        PropTypes.shape({})
    ]).isRequired,
    onClick: PropTypes.func,
    id: PropTypes.number,
    styles: PropTypes.objectOf(PropTypes.string)
};

OnRowClick.defaultProps = {
    onClick: noop,
    id: 0,
    styles: defaultStyles
};

export default OnRowClick;
